module.exports = __webpack_public_path__ + "img/wx.b6bb2777.png";